import { z } from "zod";

export const ROLES = [
  { value: "admin", labelKey: "role.admin" },
  { value: "ops", labelKey: "role.ops" },
  { value: "viewer", labelKey: "role.viewer" },
] as const;

export const userFormSchema = z.object({
  email: z.string().min(1, "create.err_email_required").email("create.err_email_required"),
  display_name: z.string().min(1, "create.err_name_required"),
  role_names: z.array(z.string()).min(1, "create.err_roles_required"),
});

export type UserFormValues = z.infer<typeof userFormSchema>;
